import { ehProdutoAdicionais } from "../componentes/CardapioContext"

// Helpers de busca do cardápio: casam por nome de produto e de opções
// (passos de montagem e adicionais). O nome da categoria NÃO é critério de busca.

const casa = (texto, termo) => (texto ?? "").toString().toLowerCase().includes(termo)

// Um passo (grupo de opções, produto.opcoes) casa se o próprio nome ou o nome de
// algum item/adicional dele (passo.opcoes) casar com o termo. Sem termo → false,
// para servir de gatilho de "abrir automaticamente" (nada aberto sem busca).
export function passoCasaBusca(passo, termo) {
    if (!termo) return false
    if (casa(passo?.nome, termo)) return true
    return (passo?.opcoes ?? []).some(item => casa(item?.nome, termo))
}

// Um produto casa se o próprio nome, o nome de algum passo (produto.opcoes)
// ou o nome de algum item/adicional (passo.opcoes) casar com o termo.
export function produtoCasaBusca(produto, termo) {
    if (!termo) return true
    if (casa(produto?.nome, termo)) return true
    return (produto?.opcoes ?? []).some(passo => passoCasaBusca(passo, termo))
}

// Uma categoria entra no resultado apenas se tiver algum produto (não o produto
// especial "Adicionais") ou opção de produto que case com o termo. O nome da
// categoria em si não é usado como critério.
export function categoriaCasaBusca(categoria, termo) {
    if (!termo) return true
    return (categoria?.produtos ?? []).some(
        produto => !ehProdutoAdicionais(produto) && produtoCasaBusca(produto, termo)
    )
}
